import { Input, Link } from "@heroui/react";
import { type Address, type Hash, isAddress, isHash } from "viem";

export function ManualClaimDepositForm({
  l1TokenAddress,
  amount,
  messageHash,
  messageIndex,
  l2BlockNumber,
  setL1TokenAddress,
  setAmount,
  setMessageHash,
  setMessageIndex,
  setL2BlockNumber,
}: {
  l1TokenAddress: Address | undefined;
  amount: bigint | undefined;
  messageHash: Hash | undefined;
  messageIndex: bigint | undefined;
  l2BlockNumber: number | undefined;
  setL1TokenAddress: (address: Address | undefined) => void;
  setAmount: (amount: bigint | undefined) => void;
  setMessageHash: (hash: Hash | undefined) => void;
  setMessageIndex: (index: bigint | undefined) => void;
  setL2BlockNumber: (blockNumber: number | undefined) => void;
}) {
  return (
    <>
      <div className="flex items-center justify-between w-full">
        <div className="font-semibold">L1 Parameters</div>
        <Link href="#" isExternal showAnchorIcon>
          Ethereum explorer
        </Link>
      </div>
      <Input
        label="L1 token address"
        name="l1TokenAddress"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isAddress(value)) return "Invalid address";
        }}
        value={l1TokenAddress}
        onValueChange={(value) => setL1TokenAddress(value as Address)}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />{" "}
      <Input
        label="Amount"
        name="amount"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          try {
            if (value.length === 0 || !BigInt(value)) return "Invalid number";
          } catch {
            return "Invalid number";
          }
        }}
        value={amount?.toString()}
        onValueChange={(value) => setAmount(BigInt(value))}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <Input
        label="L1 to L2 message hash"
        name="messageHash"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isHash(value)) return "Invalid value";
        }}
        value={messageHash}
        onValueChange={(value) => setMessageHash(value as Hash)}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <Input
        label="L1 to L2 message index"
        name="messageIndex"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isHash(value)) return "Invalid value";
        }}
        value={messageIndex?.toString()}
        onValueChange={(value) => setMessageIndex(BigInt(value))}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <div className="flex items-center justify-between w-full">
        <div className="font-semibold">L2 Parameters</div>
        <Link href="#" isExternal showAnchorIcon>
          Aztec explorer
        </Link>
      </div>
      <Input
        label="L2 block number"
        name="l2BlockNumber"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (value.length === 0 || !Number.isFinite(+value)) return "Invalid number";
        }}
        value={l2BlockNumber?.toString()}
        onValueChange={(value) => setL2BlockNumber(Number(value))}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
    </>
  );
}
